import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  percent,
  datasetXY,
  xBand,
  yLinear,
  initArea,
  lineAreaAnimation,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotAdapter,
  initPivot,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  stackInverse,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  pointStyle,
  lineStyle,
  areaStyle,
  verticalCrosshairLine,
  progressive,
  colorLegend,
  colorAdapter,
  linearColor,
  pivotColorLegend,
  pointStateDimensionHover,
  colorPointStyleFill,
  colorLineStyleFill,
  colorAreaStyleFill,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const areaPercent: VChartSpecPipeline = [
  fontFamilyTheme,
  initArea,
  lineAreaAnimation,
  regionPadding,
  stackInverse,
  colorAdapter(color, linearColor),
  backgroundColor,
  percent,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairLine,
  colorPointStyleFill(pointStyle),
  pointStateDimensionHover,
  colorLineStyleFill(lineStyle),
  colorAreaStyleFill(areaStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

const pivotAreaPercent: PivotChartSpecPipeline = [
  initPivot,

  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initArea,
    lineAreaAnimation,
    regionPadding,
    stackInverse,
    colorAdapter(color, linearColor),
    backgroundColor,
    percent,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    label,
    brush,
    tooltip({ titleEncoding: 'x' }),
    verticalCrosshairLine,
    colorPointStyleFill(pointStyle),
    pointStateDimensionHover,
    colorLineStyleFill(lineStyle),
    colorAreaStyleFill(areaStyle),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const areaPercentSpecPipeline = [pivotAdapter(areaPercent, pivotAreaPercent)]
